var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileBuilderOverallgpa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.036,
    height: 47,
    viewBox: "0 0 47.036 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x30_4_sale",
    transform: "translate(-1 -1.023)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_48362",
    "data-name": "Group 48362",
    transform: "translate(1 1.023)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_55642",
    "data-name": "Path 55642",
    d: "M46.86,21.655l-1.373-1.373a3.182,3.182,0,0,1-.7-2.6l.5-1.877a4.037,4.037,0,0,0-2.85-4.934l-1.875-.5a3.193,3.193,0,0,1-1.908-1.9l-.5-1.877a4.094,4.094,0,0,0-4.936-2.85l-1.875.5a3.358,3.358,0,0,1-2.6-.7L27.367,2.163a4.133,4.133,0,0,0-5.7,0L20.293,3.538a3.36,3.36,0,0,1-2.6.7l-1.874-.5a4.091,4.091,0,0,0-4.936,2.85l-.5,1.874a3.18,3.18,0,0,1-1.907,1.908l-1.877.5A4.032,4.032,0,0,0,3.745,15.8l.5,1.878a3.183,3.183,0,0,1-.7,2.6L2.176,21.656a4.037,4.037,0,0,0,0,5.7l1.373,1.373a3.182,3.182,0,0,1,.7,2.6l-.5,1.877A4.037,4.037,0,0,0,6.6,38.142l1.874.5a3.192,3.192,0,0,1,1.91,1.9l.5,1.877a4.1,4.1,0,0,0,4.934,2.849l1.877-.5a3.36,3.36,0,0,1,2.6.7l1.373,1.372a4.035,4.035,0,0,0,5.7,0l1.375-1.373a3.38,3.38,0,0,1,2.6-.7l1.874.5a4.014,4.014,0,0,0,1.038.136h0a4.037,4.037,0,0,0,3.9-2.987l.5-1.872a3.193,3.193,0,0,1,1.908-1.91l1.875-.5a4.035,4.035,0,0,0,2.849-4.934l-.5-1.878a3.183,3.183,0,0,1,.7-2.6l1.373-1.373a4.039,4.039,0,0,0,0-5.7ZM13.543,18.233a4.7,4.7,0,1,1,4.7,4.7A4.709,4.709,0,0,1,13.543,18.233Zm5.812,13.652a1.568,1.568,0,0,1-2.217-2.217L29.681,17.125A1.568,1.568,0,1,1,31.9,19.342Zm11.435,3.6a4.7,4.7,0,1,1,4.7-4.7A4.709,4.709,0,0,1,30.79,35.48Z",
    transform: "translate(-1 -1.023)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2840",
    "data-name": "Ellipse 2840",
    cx: 1.568,
    cy: 1.568,
    r: 1.568,
    transform: "translate(28.222 28.185)",
    fill: "#387f75"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2841",
    "data-name": "Ellipse 2841",
    cx: 1.568,
    cy: 1.568,
    r: 1.568,
    transform: "translate(15.679 15.642)",
    fill: "#387f75"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBuilderOverallgpa);
export default __webpack_public_path__ + "static/media/profile-builder-overallgpa.09488b6dbb00d0f484427b934b41f8bc.svg";
export { ForwardRef as ReactComponent };